import { useState } from "react";
import FullScreenDialog from "../../../../Components/FullScreenDialog";
import { useNavigate } from "react-router-dom";


const CompletionDialog = ({ mutationData, onClose }) => {
    const [copied, setCopied] = useState(false);
    const navigate = useNavigate();

    const handleComplete = () => {
        if (onClose) onClose()
        navigate("..")
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(mutationData.applicantUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <FullScreenDialog
            text={
                <div className="flex flex-col gap-1 items-center text-justify">
                    <span>Background Request is created successfully. </span>
                    <span className="pb-2">An email has been sent to the candidate. </span>
                    <span>You can manually provide the link to applicant:</span>
                    <div className="flex items-center gap-2 py-1">
                        <a
                            href={mutationData.applicantUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 underline break-all hover:text-blue-800"
                        >
                            Background Check Form Link
                        </a>
                        <button
                            className="ml-2 p-1 rounded hover:bg-gray-200 border border-gray-300"
                            title={copied ? "Copied!" : "Copy link"}
                            onClick={handleCopy}
                        >
                            {copied ? (
                                // Tick mark SVG
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="green" className="w-5 h-5">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                </svg>
                            ) : (
                                // Improved copy SVG
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor" className="w-5 h-5">
                                    <rect x="8" y="8" width="10" height="12" rx="2" className="fill-white" />
                                    <rect x="4" y="4" width="10" height="12" rx="2" className="fill-white" />
                                    {/* <path strokeLinecap="round" strokeLinejoin="round" d="M16 8V6a2 2 0 00-2-2H6a2 2 0 00-2 2v10a2 2 0 002 2h2" /> */}
                                    {/* <path strokeLinecap="round" strokeLinejoin="round" d="M8 16h8a2 2 0 002-2V8a2 2 0 00-2-2H8a2 2 0 00-2 2v8a2 2 0 002 2z" /> */}
                                </svg>
                            )}
                        </button>
                    </div>
                </div>
            }
            onSubmit={handleComplete}
        />
    );
}

export default CompletionDialog
